import SectionBar from "components/v2/section-bar/SectionBar";
import SidebarDivider from "components/v2/loan-centric-sidebar-nav/SidebarDivider";
import MainSidebarSection from "components/v2/loan-centric-sidebar-nav/MainSidebarSection";
import { Section, SectionType } from "pages/application/applicationService";

export interface ApplicationSidebarNavProps {
  readonly activeSection: SectionType;
  readonly sections: Section[];
}

export default function ApplicationSidebarNav({ activeSection, sections }: ApplicationSidebarNavProps) {
  return (
    <div className="application-sidebar-nav" data-testid="application-sidebar-nav">
      <MainSidebarSection />
      <SidebarDivider />
      <SectionBar activeSection={activeSection} sections={sections} />
    </div>
  );
}
